(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function addAnimateDelayToSlides() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item');
      slideItems.forEach(function(slideItem, index) {
        if (index > 0) {
          const contentSlides = slideItem.querySelectorAll('.content-slide');
          contentSlides.forEach(function(contentSlide) {
            contentSlide.classList.add('animate-delay');
          });
        }
      });
    });
  }

  // Force the slide's motion content (title/subtitle/button) to be visible.
  // The theme's Motion.animate sometimes never fires for slides inside a fade
  // swiper because the slide starts hidden; we apply the final visible state
  // directly so the content always renders.
  function revealSlideMotion(slide) {
    if (!slide) return;
    var motions = slide.querySelectorAll('motion-element');
    motions.forEach(function(m) {
      try {
        m.classList.remove('animate-delay');
        m.style.opacity = '1';
        m.style.transform = 'translateY(0)';
        m.style.visibility = 'visible';
      } catch (e) {}
    });
  }

  function revealActiveSlides() {
    document.querySelectorAll('.swiper-wrapper_parent').forEach(function(wrap) {
      var active = wrap.querySelector('.swiper-slide_item.swiper-slide-active') ||
                   wrap.querySelector('.swiper-slide_item');
      if (active) revealSlideMotion(active);
    });
  }

  function watchSlideParents() {
    document.querySelectorAll('.swiper-wrapper_parent').forEach(function(wrap) {
      if (wrap.__slideObs) return;
      wrap.__slideObs = true;
      var obs = new MutationObserver(function() {
        var active = wrap.querySelector('.swiper-slide_item.swiper-slide-active');
        if (active) revealSlideMotion(active);
      });
      wrap.querySelectorAll('.swiper-slide_item').forEach(function(s) {
        obs.observe(s, { attributes: true, attributeFilter: ['class'] });
      });
      var first = wrap.querySelector('.swiper-slide_item.swiper-slide-active') ||
                  wrap.querySelector('.swiper-slide_item');
      if (first) revealSlideMotion(first);
    });
  }

  function initSlideContentVisibility() {
    addAnimateDelayToSlides();
    revealActiveSlides();
    watchSlideParents();
  }

  document.addEventListener('DOMContentLoaded', initSlideContentVisibility);
  document.addEventListener('load', initSlideContentVisibility);
  window.addEventListener('load', initSlideContentVisibility);
  setTimeout(initSlideContentVisibility, 300);
  setTimeout(initSlideContentVisibility, 1200);

  function setActiveSlide(swiperEl, slide) {
    if (!swiperEl || !slide) return;
    var slides = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide_item'));
    var index = slides.indexOf(slide);
    if (index < 0) return;
    if (swiperEl.swiper && typeof swiperEl.swiper.slideToLoop === 'function') {
      swiperEl.swiper.slideToLoop(index, 400);
    } else if (swiperEl.swiper && typeof swiperEl.swiper.slideTo === 'function') {
      swiperEl.swiper.slideTo(index, 400);
    } else {
      slides.forEach(function(s, i) {
        s.classList.toggle('swiper-slide-active', i === index);
        s.style.opacity = i === index ? '1' : '';
        s.style.visibility = i === index ? 'visible' : '';
      });
    }
    revealSlideMotion(slide);
    setTimeout(function() { revealSlideMotion(slide); }, 500);
  }

  function gotoSelectedSlideBlock(event) {
    try {
      var blockEl = event && event.target;
      if (!blockEl) return;
      var slide = blockEl.classList && blockEl.classList.contains('swiper-slide_item')
        ? blockEl
        : blockEl.closest && blockEl.closest('.swiper-slide_item');
      if (!slide) return;
      var swiperEl = slide.closest('.swiper');
      if (!swiperEl) return;
      setActiveSlide(swiperEl, slide);
    } catch (e) {}
  }

  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initSlideContentVisibility);
    document.addEventListener('shopify:section:load', initSlideContentVisibility);
    document.addEventListener('shopify:block:select', initSlideContentVisibility);
    document.addEventListener('shopify:block:select', gotoSelectedSlideBlock);

    function forceInitLazySlideParents() {
      try {
        document.body.classList.add('swiper-lazy');
        var nodes = document.querySelectorAll('.swiper-wrapper_parent');
        nodes.forEach(function(wrap) {
          var swiperEl = wrap.closest('.swiper');
          if (!swiperEl) return;
          if (swiperEl.classList.contains('lazy-loading-swiper-after')) {
            swiperEl.classList.remove('lazy-loading-swiper-after');
          }
          if (!swiperEl.swiper && typeof swiperEl.initSlide === 'function') {
            try { swiperEl.initSlide(); } catch (e) {}
          }
        });
        setTimeout(initSlideContentVisibility, 100);
      } catch (e) {}
    }
    document.addEventListener('DOMContentLoaded', forceInitLazySlideParents);
    document.addEventListener('shopify:section:load', forceInitLazySlideParents);
    setTimeout(forceInitLazySlideParents, 800);
  }
  } catch(e) { console.error(e); }
})();

})();
